export const joinRoom = async ({
  socket,
  room,
  profile,
  cartProducts = [],
  dispatch,
  updateCurrentRoom,
  updateSelectedRoom,
  isPublic = true,
  messageType = 'orders',
  current_room,
  title,
  totalPrice,
  symbol,
}) => {
  if (!socket || !room) return;

  await socket.emit('join-room', room, current_room);

  const today = new Date();
  const minutes = today.getMinutes().toString().padStart(2, '0');
  const time = `${today.getHours()}:${minutes}`;

  await socket.emit(
    'message-room',
    room,
    messageType,
    profile,
    time,
    today.toISOString().split('T')[0], // Today's Date in YYYY-MM-DD format
    false,
    [],
    cartProducts,
    true,
    totalPrice,
    symbol
  );

  dispatch(updateCurrentRoom(room));
  dispatch(updateSelectedRoom({ room, status: 'online', order_title: title }));
};
